module.exports = __webpack_public_path__ + "img/img33.addbeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img33.png
// module id = 211
// module chunks = 0